import {Component, Input, OnInit, Output, EventEmitter, HostListener} from '@angular/core';

@Component({
  selector: 'app-rounded-button',
  templateUrl: './rounded-button.component.html',
  styleUrls: ['./rounded-button.component.scss']
})
export class RoundedButtonComponent implements OnInit {

  @Input() isLoading = false;
  @Input() minWidth: any = 'auto';
  @Input() isConfirmedPage = false;

  constructor() { }

  ngOnInit(): void {
  }
}
